import { EventActionEvent } from "@closerplatform/spinner-openapi";
import React from "react";
import { intl } from "../../../i18n/TypedIntl";
import { assertUnreachable } from "../../../utils/ts-utils";
import { AutoComplete, AutoCompleteProps } from "../autoComplete/autoComplete";

interface Props extends Partial<Omit<AutoCompleteProps<EventActionEvent>, "onChange">> {
  onChange: (value: EventActionEvent) => void;
  currentEvent?: EventActionEvent;
}

export const EventPicker = ({
  onChange,
  currentEvent,
  itemsProvider = () => Object.values(EventActionEvent),
  ...rest
}: Props) => {
  return (
    <AutoComplete<EventActionEvent>
      {...rest}
      onChange={(value: EventActionEvent | "") => (value ? onChange(value) : undefined)}
      itemsProvider={itemsProvider}
      itemToString={mapEventToString}
      placeholder={intl.formatMessage("eventPicker.placeholder")}
      readOnly
      inputValue={currentEvent ? mapEventToString(currentEvent) : undefined}
    />
  );
};

export const mapEventToString = (event: EventActionEvent | null): string => {
  if (event) {
    switch (event) {
      case EventActionEvent.ThreadOpenedOutsideWorkingHours:
        return intl.formatMessage("settings.eventActions.threadOutsideWorkingHours");
      case EventActionEvent.ClosedUnsolvedThreadAction:
        return intl.formatMessage("settings.eventActions.closedUnsolvedThread");
      case EventActionEvent.ClosedSolvedThreadAction:
        return intl.formatMessage("settings.eventActions.closedSolvedThread");
      case EventActionEvent.ThreadOpened:
        return intl.formatMessage("settings.eventActions.threadOpened");
      case EventActionEvent.AssignedConversationAction:
        return intl.formatMessage("settings.eventActions.conversationAssignedToAgent");
      case EventActionEvent.ThreadOpenedAgentsUnavailable:
        return intl.formatMessage("settings.eventActions.threadOpenedAgentsUnavailable");
      case EventActionEvent.WidgetOpenedNoOpenThread:
        return intl.formatMessage("settings.eventActions.widgetOpened");
      default:
        assertUnreachable(event);
        return "";
    }
  }
  return "";
};
